import axiosInstance from "@/utils/axios";

const RECHARGE_TRIGGER_API=`/v1/payments/createPaymentSession`;
const GENERATE_PAYMENT_LINK = `/v1/payments/generatePaymentLink`;
const PAYMENT_LIST = `/v1/payments/getPlanList`;
const STRIPE_PAYMENT_API = `/v4/user-invoices/generatePayLink`;

export const getPaymentList = () => {
  return axiosInstance.get(PAYMENT_LIST);
};

export const generatePaymentLink = (payload) => {
  return axiosInstance.post(GENERATE_PAYMENT_LINK,payload)
};


export const rechargeTriggered = (payload) => {
    return axiosInstance.post(RECHARGE_TRIGGER_API, payload);
  };

export const generateStripePaymentLink = (payload) => {
  return axiosInstance.post(STRIPE_PAYMENT_API, payload);
};


